// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsLinKCell_container__3Jo-Q","link":"TermsLinKCell_link__1qwJ0"};